import Page from '@/found/components/table_page/table_page.vue';

export default {
  extends: Page,
  props: {
    propsObj: Array,
  },
  data() {
    return {
      formConfig: {},
      configs: {
        formConfig: {},
      },
      modalConfig: {},
      tableData: [],
    };
  },
  components: {},
  watch: {
    propsObj(v) {
      console.log(v);
      if (v.length > 0) {
        v.forEach((item) => {
          if (item.skuPropertiesName) {
            const skuObj = JSON.parse(item.skuPropertiesName);
            item.skuPropertiesName = skuObj[0].v;
          }
        });
        this.tableData = v;
      }
    },
  },
  created() {
    this.getConfigList('pro_list');
  },
  methods: {
    setColumn(col) {
      const rowData = col;

      if (col.field === 'picPath') {
        rowData.className = 'formatter-image';
        rowData.type = 'html';
        rowData.formatter = ({ row }) => `<img src=${row.picPath}></img>`;
      }
      return rowData;
    },
  },
};
